import { MapTo } from '@adobe/cq-react-editable-components';
import React, { Component } from 'react';
import TestComponent from './TestComponent';

const TestComponentEditConfig = {
  emptyLabel: 'Test',

  isEmpty: function(props: any): boolean {
    return !props;
  },
};

class TestComponentWrapper extends Component {
  props: any;

  render(): JSX.Element {
    const testComponentProps = {
      title: this.props.buttonTitle,
      onClick: this.props.onClick,
    };

    return (
      <div>
        <TestComponent {...testComponentProps} />
      </div>
    );
  }
}

export default MapTo('workplace-spa/components/testcomponent')(TestComponentWrapper, TestComponentEditConfig);
